<template>
   <div>
    <v-alert v-if="show_alert" :type="message_type" > {{alert_message}} </v-alert>

        <v-toolbar
              :color="colorinfos.buttonCartColor" style="  border:0; box-shadow:none"
              dark >
               <v-spacer>
            <v-toolbar-title class="text-center"  >{{current_title_level}} </v-toolbar-title>
             </v-spacer>
        </v-toolbar>
<v-form v-if="niveau==1" v-model="validkyc" ref="form" id="inscriptionForm"   lazy-validation>
        <v-container>
          <v-row class="kyc1">


             <span>{{dictionnary.sub_title_card}}</span>
             <p>{{dictionnary.description_card}}</p>

            <v-col   cols="12" md="12" >
               <v-text-field
                 v-model="tel"
                 solo
                 v-bind="myPropsElement.tel"
                 @focus="myPropsElement.tel.error = false; myPropsElement.tel['error-messages'] ='';valid=true"
                label="Numéro de téléphone"
                required :rules="rule_tel"
              ></v-text-field>

              <v-text-field
                    v-model="complete_name"
                    solo
                    v-bind="myPropsElement.complete_name"
                    @focus="myPropsElement.complete_name.error = false; myPropsElement.complete_name['error-messages'] =''"
                    label="Votre nom au complet"
                    required
                    :rules="rule_alphnum"
                ></v-text-field>
                    <v-checkbox v-model="remember_me" v-bind="myPropsElement.remember_me"
   label="Se souvenir de moi" dark

 ></v-checkbox>
        <div class="justify-center card-action-bottom">
                      <v-btn
                        color="white"   class="btn-cart"
                        @click.prevent="gobackward" :style="{color:colorinfos.buttonCartColor}"
                      > <v-icon>mdi-undo</v-icon> </v-btn>

                      <v-btn type  :disabled="!validkyc"
                        color="white" class="btn-cart"
                         @click.prevent="savekycform" :style="{color:colorinfos.buttonCartColor}"
                      >valider</v-btn>
        </div>
      </v-col>

        </v-row>
      </v-container>
    </v-form>
    <div v-if="niveau==2">


     <v-container  >
            <v-row>

      <v-card :color="colorinfos.buttonCartColor" class="card-is-your-number" min-width="100%"  outlined dark >
        <v-card-title class="justify-center  titleme"><strong>{{tel}}</strong> </v-card-title>
        <v-card-actions>
             <v-btn color="white"   class="btn-cart" :style="{color:colorinfos.buttonCartColor}" @click.prevent="gostage(1)" >
               <v-icon>mdi-undo</v-icon>
            </v-btn>
              <v-btn type  :disabled="!validkyc" :style="{color:colorinfos.buttonCartColor}"
                        color="white" class="btn-cart"
                         @click.prevent="gotoTektalForm"
                      >Je confirme</v-btn>
        </v-card-actions>


      </v-card>
      </v-row>
              </v-container >


    </div>
    <div v-if="niveau==3">

        <v-form v-if="!show_alert" v-model="valid" ref="form" id="inscriptionForm"   lazy-validation>
        <v-container>
         <v-row>

            <v-col cols="12" md="6" class="margin-padding-col-canceled"   >
                <v-text-field
                        v-model="name"
                        solo
                        v-bind="myPropsElement.name"
                        @focus="myPropsElement.name.error = false; myPropsElement.name['error-messages'] =''"


                         label="Prénom"
                        required
                        :rules="rule_alphnum"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="6"  class="margin-padding-col-canceled"  >
                <v-text-field
                        solo
                        v-model="lastname"
                        v-bind="myPropsElement.lastname"
                        @focus="myPropsElement.lastname.error = false; myPropsElement.lastname['error-messages'] =''"


                         label="Nom de famille"
                        required
                        :rules="rule_alphnum"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="6" class="margin-padding-col-canceled"   >

              <v-text-field
                 v-model="tel"
                 solo
                 v-bind="myPropsElement.tel"
                 @focus="myPropsElement.tel.error = false; myPropsElement.tel['error-messages'] ='';valid=true"
                label="Numéro de téléphone"
                required :rules="rule_tel"
              ></v-text-field>
              </v-col>
                <v-col class="margin-padding-col-canceled" cols="12" md="6"  >
                 <v-text-field
                        v-model="email"
                        type="email"
                        solo
                        label="E-mail"
                        :rules="rule_email"
                        required
                        v-bind="myPropsElement.email"
                        @focus="myPropsElement.email.error = false; myPropsElement.email['error-messages'] ='';valid=true"

                ></v-text-field>
                </v-col>
                <v-col cols="12" md="12"  >
                    <v-text-field v-if="inputIndication"
                            v-model="adress_indication"
                            type="text"
                            solo
                            label="Indiquer votre adress Ex: Scart Urbam derrière Numéro UNO"
                            :rules="rule_alphnum"
                            required
                            v-bind="myPropsElement.adress_indication"
                    ></v-text-field>

               <v-select  label="Civilité" :rules="rule_alphnum"  v-model="civility"
                    v-bind="myPropsElement.civility"
                    @focus="myPropsElement.civility.error = false; myPropsElement.civility['error-messages'] =''"
                    solo
                    :items="list_civilities">
              </v-select>

            <v-card-actions>
             <v-btn color="white"   class="btn-cart" :style="{color:colorinfos.buttonCartColor}" @click.prevent="gostage(2)" >
               <v-icon>mdi-undo</v-icon>
            </v-btn>
              <v-btn type  :disabled="!validkyc"
                        color="white" class="btn-cart" :style="{color:colorinfos.buttonCartColor}"
                         @click.prevent="remondataOnCardBox"
                      >Passer la commande</v-btn>
        </v-card-actions>
        </v-col>
          </v-row>
        </v-container>
     </v-form>
  </div>




</div>

</template>

<script>

export default {
    title: 'Kyc',
    props: {
      getbackupkycdata: Object,
      gotoniveau: Number,
      colorinfos: Object
     },
    components: { },
    mounted(){

       console.log('on vien de juste monter form-kyc');
       console.log('QUEL EST NIVEAU DE NIVEAU =====>',this.niveau);
       this.updateTitleCart(this.niveau);
       console.log('la valeur de pros getbackupkycdata apres montage',this.getbackupkycdata)
       this.fillkycform(this.getbackupkycdata);
       this.getDataFromLocalStorage();


    },
    data(){
       return{
         text_snackbar : '',
         snackbar: false,
         inputIndication : true,
         dictionnary : {
              title_card : "Passer rapidement votre commande en remplissant ce formulaire" ,
              sub_title_card:'',
              description_card: '',
          },
          show_alert: false,
          message_type:'success',
          alert_message: null,
          nb_items: 0,
          cart : [],

          colorgreen : '#00a65ad4',
          colorred : '#EF323D',



          name: null,
          lastname: null,
          country : null,
          email: null,
          civility: null,
          complete_name:'',
          hycform: 1,
          remember_me: false,
          tel:'',
          kyc_datas : {
            tel: '',
            complete_name: '',
            remember_me:''
          },
          niveau: 1,
          correct: false,
          valid:false,
          validkyc:false,
          adress_indication: '',
          list_civilities : ['Mlle', 'Madame', 'Monsieur'],
          current_title_level: '',
          titles_level: ['Vos coordonnées','Vous commandez bien avec le numéro','Validation Commande'],

          hidden:false,


          rule_required:[
            v => !!v || 'Ce champ est obligatoire, merci de le remplir',
          ],
          rule_email:[
            v => !!v || 'E-mail est requise',
            v => /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))*$/.test(v) || "Adresse e-mail incorrect"
          ],
          rule_tel : [
            v => !!v || 'Ce champ est obligatoire, merci de le remplir',
            v => /^[0-9 \n\r\-\+\,\.\']*$/.test(v) || "Caractère non autorisé"
          ],
          rule_alphnum: [
            v => !!v || 'Ce champ est obligatoire, merci de le remplir',
            v => /^[a-zA-Z0-9 àâäèéêëîïôœùûüÿçÀÂÄÈÉÊËÎÏÔŒÙÛÜŸÇ\n\r\-\,\.\']*$/.test(v) || "Caractère non autorisé"
          ],
          rule_contract:[
            v => v != 0 || "Vous devez accepter les régles d'utilisation pour pouvoir continuer"
          ],
          nameRules: [
            v => !!v || 'Name is required',
            v => v.length <= 10 || 'Name must be less than 10 characters',
          ],
          deliverycoordinate : {},
          gotcoordinate:false,

          myPropsElement : {
            email : {
                error : false,
                'error-messages' : ''
            },
            adress_indication: {
              error : false,
              'error-messages' : ''
            },
            name: {
             error : false,
            'error-messages' : ''
           },
           lastname: {
             error : false,
            'error-messages' : ''
           },
           complete_name:{
             error : false,
            'error-messages' : ''
           },
           tel: {
             error : false,
            'error-messages' : ''
           },
           localite: {
             error : false,
            'error-messages' : ''
           },
           civility:{
             error:false,
             'error-messages' : ''
           }

          },

       }
    },
    watch:{
      gotoniveau: function(value){
        console.log(' il y a un changement au niveau du NIVEAUUUUUU',value);
      }
    },
    methods :{

      updateTitleCart(level){
            this.current_title_level = this.titles_level[level-1];
            console.log('updateTitleCart('+level+') ===>',this.current_title_level);

      },
      getDataFromLocalStorage(){

        let remember_me_storage =  localStorage.getItem('remember_me');
        if( !_.isNull(remember_me_storage) )
        {
          this.chargePlaceHolder();
        }else{
          console.log('on a pas encore de local storage zer ===>',remember_me_storage)
        }
      },
      chargePlaceHolder(){

        console.log('mon charge le placeholder')
           this.complete_name = localStorage.getItem('complete_name')
           this.name = localStorage.getItem('name')
           this.lastname = localStorage.getItem('lastname')
           this.complete_name =this.name +' '+ this.lastname
           this.email = localStorage.getItem('email')
           this.tel = localStorage.getItem('tel')
           this.adress_indication = localStorage.getItem('adress_indication')
           this.civility = localStorage.getItem('civility')
           this.remember_me = localStorage.getItem('remember_me')

      },
      remondataOnCardBox(){
            let dataReport = {
                 tel:  this.tel,
                name:  this.name,
                lastname: this.lastname,
                email: this.email,
                adress_indication: this.adress_indication,
                civility: this.civility,
                remember_me: this.remember_me,
                current_position: {},
                gotcoordinate : false,
                findmyloc: {}
            }
            if(this.remember_me){
              console.log('dans remember mii',dataReport);

              _.forEach(dataReport,(valval,keydata) => {
                console.log('forEach dataReport ==>',valval,keydata)
                  console.log('setItem('+keydata+','+valval/')')
                  localStorage.setItem(keydata, valval)
              });
            }else{
               _.forEach(dataReport,(valuedata,keydata) => {
                  localStorage.removeItem('keydata')
              });
            }


          this.$emit('datareportedFromChild', dataReport);
      },
      gobackward(){
          this.fillkycbackup();

          console.log('going backward',this.kyc_datas);
          this.$emit('previous', {
            niveau:0,
            kyc_datas: this.kyc_datas
            });
          //this.$parent.activekyc = false;
      },
      verifyform(){
         let go = true;
        if( _.isEmpty(this.tel) )
         {
            console.log('tel ---> vid');
            this.myPropsElement.tel.error=true;
            this.myPropsElement.tel['error-messages'] = "merci de remplir ce champ pour continuer";
            go = false;
         } //||
         if( _.isEmpty(this.complete_name)){
            console.log('completename ---> vid');
            this.myPropsElement.complete_name.error=true;
            this.myPropsElement.complete_name['error-messages'] = "merci de remplir ce champ pour continuer";
            go = false;

         }
         return go;
      },
      savekycform(){
           if(this.verifyform())
           {
               console.log('on vient de valider la commande')
               this.fillkycbackup();
              console.log('kyc_datas we geet' , this.kyc_datas);
              this.gostage(2);
           }
      },
      gotoTektalForm(){

        this.gostage(3);
        let completename = this.complete_name.split(' ');
        this.name = completename[0];
        if (!_.isUndefined(completename[1]))
        {
          this.lastname = completename[1];
        }
      },

      gostage(stage){
          console.log('on retourne au niveau precedant',stage)
          this.niveau  = parseInt(stage);
          this.updateTitleCart(this.niveau);
          if(this.niveau === 3){
              console.log('GEOOO=====> on va au niveau 3 avec la geolocalisation');
          }
      },
      fillkycform(valuedone){
           this.tel = valuedone.tel
           this.complete_name = valuedone.complete_name
           this.remember_me = valuedone.remember_me
      },
      fillkycbackup(){
          this.kyc_datas.tel = this.tel
          this.kyc_datas.complete_name = this.complete_name
          this.kyc_datas.remember_me = this.remember_me
      }


    }
}
</script>

<style >
.card-is-your-number{
    padding-bottom: 25px;
}
.margin-padding-col-canceled{
   padding-bottom: 0px !important;
    padding-top: 2px !important;
}

.validation-h3{
  position: relative;
  margin-bottom: 12px;
  margin-top: 22px;
  margin-left: 50%;
  transform: translateX(-45%);
  min-width: 300px;
  font-weight: bold;
  color: #fafafa;

}
</style>





// WEBPACK FOOTER //
// src/components/pieces/kyc.vue